exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TrainingContentCard-module__wrapper___3A0a-{background-color:#ececec;padding:1rem;border-radius:17px;display:grid;grid-template-columns:auto 1fr auto;gap:1rem}.TrainingContentCard-module__wrapper___3A0a- .TrainingContentCard-module__handler___3ZqWp{grid-column:1;align-self:center}.TrainingContentCard-module__wrapper___3A0a- .TrainingContentCard-module__trash___1iclc{grid-column:3;align-self:center}", ""]);

// exports
exports.locals = {
	"wrapper": "TrainingContentCard-module__wrapper___3A0a-",
	"handler": "TrainingContentCard-module__handler___3ZqWp",
	"trash": "TrainingContentCard-module__trash___1iclc"
};